import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../helpers/api_helper";
import * as URL from "../../helpers/url_helper";

const api = new APIClient();

export const fetchWidget = createAsyncThunk("widgets/fetch",
  async (websiteId) => api.get(`${URL.GET_WIDGET}/${websiteId}`));

export const enableWidget = createAsyncThunk("widgets/enable",
  async (websiteId) => api.create(`${URL.ENABLE_WIDGET}/${websiteId}/enable`, {}));

export const disableWidget = createAsyncThunk("widgets/disable",
  async (websiteId) => api.create(`${URL.DISABLE_WIDGET}/${websiteId}/disable`, {}));

export const updateWidgetConfig = createAsyncThunk("widgets/updateConfig",
  async ({ websiteId, config }) => api.put(`${URL.UPDATE_WIDGET_CONFIG}/${websiteId}/config`, config));

export const regenerateWidgetKey = createAsyncThunk("widgets/regenerate",
  async (websiteId) => api.create(`${URL.REGENERATE_WIDGET_KEY}/${websiteId}/regenerate-key`, {}));

/** Create a placeholder Website that only hosts a widget (for users who already have an external site). */
export const createExternalWidget = createAsyncThunk("widgets/createExternal",
  async (payload) => api.create(`/widgets/external`, payload || {}));

const slice = createSlice({
  name: "widgets",
  initialState: { current: null, loading: false, saving: false, error: null },
  reducers: {},
  extraReducers: (b) => {
    [fetchWidget, enableWidget, disableWidget, updateWidgetConfig, regenerateWidgetKey, createExternalWidget].forEach(t => {
      b.addCase(t.pending, (s) => { s.loading = true; s.error = null; });
      b.addCase(t.fulfilled, (s, a) => { s.loading = false; s.current = a.payload || s.current; });
      b.addCase(t.rejected, (s, a) => { s.loading = false; s.error = a.error.message; });
    });
  }
});

export default slice.reducer;
